import { useRootData } from './use-root-data';

/**
 * Hook to check if the current browser is Safari.
 */
export function useIsSafari() {
    const { device } = useRootData();

    return device.browser.isSafari;
}
